import { useState } from "react";
import { alertService } from "../services/AlertService";
import { handleError } from "../model/handleError";
import LezioniService from "../services/LezioniService/LezioniService";

const useLezioni = () => {
  const [loadingState, setLoadingState] = useState({
    getLezioniByIdClasse: false,
    isLoadingLezioneCreating: false,
    isLoadingLezioneDelete: false,
    isLoadingLezioneUpdate: false,
  });

  const [modalState, setModalState] = useState({
    showModalInfoLezione: false,
    showModalCreateLezione: false,
    showModalDeleteLezione: false,
    showModalUpdateLezione: false,
  });

  const getLezioniByIdClasse = async (classId) => {
    setLoadingState({ ...loadingState, getLezioniByIdClasse: true });
    try {
      let response = await LezioniService.getLezioniByIdClasse(classId);
      return response;
    } catch (error) {
      alertService.error(
        "Si è verificato un errore nel tentativo di visualizzare le lezioni",
        { autoClose: true }
      );
    } finally {
      setLoadingState({ ...loadingState, getLezioniByIdClasse: false });
    }
  };

  const createLezione = async (data) => {
    setLoadingState({ ...loadingState, isLoadingLezioneCreating: true });
    try {
      let response = await LezioniService.createLezione(data);
      alertService.success("Lezione creata con successo", { autoClose: true });
      setModalState({ ...modalState, showModalCreateLezione: false });
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingLezioneCreating: false });
    }
  };

  const deleteLezione = async (id) => {
    try {
      setLoadingState({ ...loadingState, isLoadingLezioneDelete: true });
      await LezioniService.deleteLezione(id);
      alertService.success("Lezione eliminata con successo", {
        autoClose: true,
      });
      setModalState({ ...modalState, showModalDeleteLezione: false });
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingLezioneDelete: false });
    }
  };

  const updateLezione = async (data) => {
    try {
      setLoadingState({ ...loadingState, isLoadingLezioneUpdate: true });
      let response = await LezioniService.updateLezione(data);
      alertService.success("Lezione aggiornata con successo", {
        autoClose: true,
      });
      setModalState({ ...modalState, showModalUpdateLezione: false });
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingLezioneUpdate: false });
    }
  };

  return {
    getLezioniByIdClasse,
    createLezione,
    deleteLezione,
    updateLezione,
    loadingStateLezioni: loadingState,
    modalStateLezioni: modalState,
  };
};

export default useLezioni;
